module.exports = __webpack_public_path__ + "img/jev.9f21b8ce.png";